<!--高度可控树
逻辑：这是个list，每一级的内容由外部方法获取到的内容填充
slot中通过<template slot-scope="slotProps">里面的slotProps获取参数
界面渲染由使用者决定
-->
<template>
	<div class="hideBar" style="overflow: hidden;">
		<template v-for="(item,index) in dataList">
			<slot :item="item" :index="index" :nowFloor="nowFloor" :openAble="openAble(item,index)">
			</slot>
			<customer-tree :dataList="getNextMethod(item,index)" :getNextMethod="getNextMethod" :key="index" :nowFloor="nowFloor+1"
			 v-show="openAble(item,index)" :openAbleMethod="openAbleMethod">
				<template slot-scope="slotProps">
					<slot :item="slotProps.item" :index="slotProps.index" :nowFloor="slotProps.nowFloor" :openAble="slotProps.openAble"></slot>
				</template>
			</customer-tree>
		</template>
	</div>
</template>

<script>
	export default {
		name: 'customerTree',
		components: {},
		props: {
			//数据列表
			dataList: {
				type: Array,
				default () {
					return []
				}
			},
			//数据列表中，用于获取下一级内容的方法，参数是对象+当前级下标，默认是返回next字段
			getNextMethod: {
				type: Function,
				default (item, index) {
					return item.next
				}
			},
			//当前层级，用于让组件知道自己现在处于第几级
			nowFloor: {
				type: Number,
				default () {
					return 0
				}
			},
			//是否显示下一级的方法，默认全打开
			openAbleMethod: {
				type: Function,
				default (item, index) {
					return true
				}
			}
		},
		data() {
			return {}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			openAble() {
				return (item, index) => {
					return this.openAbleMethod(item, index)
				}
			}
		},
		watch: {},
		methods: {}
	}
</script>

<style scoped>
</style>
